import { render, staticRenderFns } from "./swiperOffers.vue?vue&type=template&id=2d69ceaf&"
import script from "./swiperOffers.vue?vue&type=script&lang=js&"
export * from "./swiperOffers.vue?vue&type=script&lang=js&"
import style0 from "./swiperOffers.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/work/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d69ceaf')) {
      api.createRecord('2d69ceaf', component.options)
    } else {
      api.reload('2d69ceaf', component.options)
    }
    module.hot.accept("./swiperOffers.vue?vue&type=template&id=2d69ceaf&", function () {
      api.rerender('2d69ceaf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/swiperOffers/swiperOffers.vue"
export default component.exports